<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-progress-bar
        v-if="isLoading"
        md-mode="indeterminate"
      />
      <div>
        <div class="header-line">
          <h3>Shortcuts Review Mode</h3>
          <md-button
            v-if="!isLoading"
            class="md-primary"
            @click="showAddDialog = true;"
          >
            Add to review
          </md-button>
        </div>

        <h4 v-if="appsInReview.length === 0">
          No apps in review mode
        </h4>
        <div v-else>
          <h4>Apps in Review Mode</h4>
          <md-table class="table">
            <md-table-row
              v-for="app in appsInReview"
              :key="app"
            >
              <md-table-cell>
                <a @click="openDetailsDialog(app)">{{ app['app_identity'] }}</a>
                <p>{{ app['app_version'] }}</p>
              </md-table-cell>
              <md-table-cell class="remove-btn-cell">
                <md-button
                  class="md-icon-button"
                  @click="removeAppFromReview(app)"
                >
                  <md-icon>
                    delete
                  </md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <md-dialog :md-active.sync="showAddDialog">
        <md-dialog-title>Put App in review mode</md-dialog-title>

        <md-field class="dialog-app-field">
          <label>App</label>
          <md-select v-model="addDialogValue">
            <md-optgroup
              v-for="[label, apps] in appsOptions"
              :key="label"
              :label="label"
            >
              <md-option
                v-for="app in apps"
                :key="app"
                :value="app"
              >
                {{ app }}
              </md-option>
            </md-optgroup>
          </md-select>
        </md-field>

        <md-field class="dialog-app-field">
          <label>App Version</label>
          <md-input
            v-model="appVersion"
            type="text"
          />
        </md-field>
        <p
          v-if="!appVersionValid"
          class="add-dialog-error"
        >
          should be valid semver format (1.1.0)
        </p>

        <span class="add-dialog-error">{{ addDialogError }}</span>

        <md-dialog-actions>
          <md-button @click="showAddDialog = false">
            Close
          </md-button>
          <md-button
            class="md-primary"
            @click="putAppInReview"
          >
            Save
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>

    <md-dialog
      :md-active.sync="detailsDialog.isActive"
      style="max-width: 650px"
    >
      <md-dialog-title>Shortcuts blocked for {{ detailsDialog.app }}:</md-dialog-title>

      <md-progress-spinner
        v-if="detailsDialog.isLoading"
        md-mode="indeterminate"
      />
      <div v-else>
        <md-table
          v-if="detailsDialog.blockedShortcuts.length > 0"
          style="padding: 0 10px"
        >
          <md-table-row>
            <md-table-head>
              ID
            </md-table-head>
            <md-table-head>
              Title
            </md-table-head>
          </md-table-row>

          <md-table-row
            v-for="shortcut in detailsDialog.blockedShortcuts"
            :key="shortcut.shortcut_id"
          >
            <md-table-cell>
              <a
                :href="'/shortcut/edit/' + shortcut.shortcut_id"
                target="_blank"
              >
                {{ shortcut.shortcut_id }}
              </a>
            </md-table-cell>
            <md-table-cell>{{ shortcut.title.en }}</md-table-cell>
          </md-table-row>
        </md-table>
        <span v-else>No blocked shortcuts</span>
      </div>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="detailsDialog.isActive = false"
        >
          Close
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import semver from "semver";

export default {
    name: "ShortcutReviewMode",
    data() {
        return {
            appVersion: "1.1.1",
            appVersionValid: true,
            groupedApps: {
                assguard: [],
                clearvpn: [],
            },
            appsInReview: [],

            isLoading: true,
            showAddDialog: false,
            addDialogValue: "",
            addDialogError: "",

            detailsDialog: {
                isActive: false,
                isLoading: false,
                blockedShortcuts: {},
                app: "",
            },
        };
    },
    computed: {
        appsOptions() {
            const options = {};
            Object.keys(this.groupedApps).forEach(key => {
                options[key] = this.groupedApps[key].filter(app => !this.appsInReview.includes(app));
            });
            return Object.entries(options);
        }
    },
    mounted() {
        Promise.all([this.fetchApps(), this.fetchAppsInReview()])
            .then(() => (this.isLoading = false));
    },
    methods: {
        fetchApps() {
            return this.$http.get("/v1/admin/store/apps").then(res => {
                this.apps = res.data.apps.map(a => a.identity);

                const groupedApps = {};

                groupedApps.assguard = this.apps.filter(app => !app.includes("clearvpn"));
                groupedApps.clearvpn = this.apps.filter(app => app.includes("clearvpn"));

                this.groupedApps = groupedApps;
            });
        },
        fetchAppsInReview() {
            return this.$http.get("/v1/admin/shortcut/review-mode/apps").then(res => {
                this.appsInReview = res.data["apps_in_review"];
            });
        },
        putAppInReview() {
            if (!this.addDialogValue) {
                this.addDialogError = "App is not selected";
                return;
            }

          this.appVersionValid = true;
          if (!semver.valid(this.appVersion)) {
            console.error("semver is invalid");
            this.appVersionValid = false;
            return;
          }
          let cleanVer =  semver.clean(this.appVersion);

          this.$http.post("/v1/admin/shortcut/review-mode/put", {
                app_identity: this.addDialogValue,
                app_version: cleanVer
            })
                .then(res => {
                    if (res.status === 200) {
                        this.$notify({
                            group: "foo",
                            title: "App added to review mode",
                        });
                    }
                })
                .then(() => this.fetchAppsInReview())
                .then(() => {
                    this.showAddDialog = false;
                })
                .catch(e => {
                    console.error(e);
                    this.addDialogError = e;
                });
        },
        removeAppFromReview(app) {
            this.$http.post("/v1/admin/shortcut/review-mode/remove", { app_identity: app["app_identity"] })
                .then(res => {
                    if (res.status === 200) {
                        this.$notify({
                            group: "foo",
                            title: "App removed from review mode",
                        });
                    }
                })
                .then(() => this.fetchAppsInReview())
                .catch(e => this.$notify({
                    group: "foo",
                    title: e,
                }));
        },
        openDetailsDialog(app) {
            this.detailsDialog.isActive = true;
            this.detailsDialog.isLoading = true;
            this.detailsDialog.app = app;

            this.$http.get(`/v1/admin/shortcut/review-mode/shortcuts/${app}`)
                .then(res => {
                    this.detailsDialog.blockedShortcuts = res.data.shortcuts;
                    this.detailsDialog.isLoading = false;
                })
                .catch(err => {
                    this.$notify({
                        group: "foo",
                        title: err,
                    });
                    console.error(err);
                    this.detailsDialog.isActive = false;
                    this.detailsDialog.isLoading = false;
                });
        },
    }
};
</script>
<style scoped lang="scss">
    .header-line {
        display: flex;
        justify-content: space-between;
    }

    .dialog-app-field {
        max-width: 400px;
        margin-left: 24px;
    }

    .add-dialog-error {
        color: red;
        margin-left: 24px;
    }

    .table {
        max-width: 500px;
    }
    .remove-btn-cell {
        max-width: 30px;
    }
</style>
